import { z } from "zod";

const ProcessorMetaDataSchema = z.object({
    status: z.enum(["running", "done", "error"]),
    summary: z.string(),
});

// [US-5924] Un item de csv_error_report est un OBJET, pas une string. Le back
// tague chaque erreur d'un `type` (content_error | missing_file | unexpected) ;
// les autres clés dépendent du type (line/error/column pour content_error,
// message pour missing_file/unexpected). passthrough() tolère les champs
// additionnels legacy. errors suit la même union que metaData : array direct
// quand le processor n'est pas oneByLaboratory, Record<labId, …> sinon.
const ProcessorErrorSchema = z.object({
    type: z.string().optional(),
    message: z.string().optional(),
    line: z.number().nullable().optional(),
    error: z.string().optional(),
    column: z.string().optional(),
    solution: z.string().optional(),
}).passthrough();

export const ProcessorSchema = z.object({
    metaData: z.union([
        ProcessorMetaDataSchema,
        z.record(z.string(), ProcessorMetaDataSchema),
    ]),
    baseClassName: z.string(),
    oneByLaboratory: z.boolean(),
    label: z.string(),
    errors: z.union([
        z.array(ProcessorErrorSchema),
        z.record(z.string(), z.array(ProcessorErrorSchema)),
    ]),
});

export const FileCompetitorUploaderProcessorSchema = ProcessorSchema
    .merge(z.object({
        fileName: z.string(),
        fileType: z.string(),
    }
    ));

export const FileCompetitorUploaderStatus = z.record(
    z.string(),
    z.union([
        z.boolean(),
        z.record(z.string(), z.boolean()),
    ])
);

export type ProcessorMetaData = z.infer<typeof ProcessorMetaDataSchema>;
export type ProcessorError = z.infer<typeof ProcessorErrorSchema>;
export type Processor = z.infer<typeof ProcessorSchema>;

/** Extrait le status direct d'un processor non-oneByLaboratory */
export function getDirectStatus(processor: Pick<Processor, "metaData" | "oneByLaboratory">): ProcessorMetaData["status"] | undefined {
    if (!processor.oneByLaboratory && "status" in processor.metaData) {
        return (processor.metaData as ProcessorMetaData).status;
    }
    return undefined;
}

export type FileCompetitorUploaderProcessor = z.infer<typeof FileCompetitorUploaderProcessorSchema>;

export type FileCompetitorUploaderStatus = z.infer<typeof FileCompetitorUploaderStatus>;
